import React from "react";
import ExploreAnimalCareBanner from "./ExploreAnimalCareBanner";
import { Container } from "@material-ui/core";
import ProcessedProducts from "../ExploreProducts/ProcessedProducts";
import "./ExploreAnimalCare.css";

export default function ExploreAnimalCare() {
  const userType = ["AHSP"];
  return (
    <>
      <ExploreAnimalCareBanner />

      <Container className="mt-5 update-container-wrapper">
        <h3 className="container-title text-center mb-4">Animal Health Products</h3>

        <ProcessedProducts type="AHP" userType={userType} cbn="true" />
      </Container>
    </>
  );
}
